"use client"

import { useEffect } from "react"
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card"
import { Button } from "@/components/ui/button"
import { useErrorReport } from "@/hooks/useErrorReport"

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useErrorReport({
    error,
    digest: error.digest,
    context: { origem: "app/error.tsx" },
  })

  useEffect(() => {
    console.error(error)
  }, [error])

  return (
    <div className="container flex items-center justify-center min-h-[60vh] py-12">
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <CardTitle className="text-2xl font-bold text-center">
            Algo deu errado
          </CardTitle>
          <CardDescription className="text-center text-muted-foreground">
            Ocorreu um erro inesperado. Por favor, tente novamente.
          </CardDescription>
        </CardHeader>
        <CardContent className="flex flex-col items-center">
          {error.digest && (
            <p className="text-xs text-muted-foreground mb-4">
              Error ID: {error.digest}
            </p>
          )}
          <Button onClick={() => reset()} variant="outline">
            Tentar novamente
          </Button>
        </CardContent>
      </Card>
    </div>
  )
}
